(function(){
  "use strict";
  var menuData = {
    "Best Sellers": { href: "/collections/best-sellers", handle: "best-sellers", desc: "Our most-loved intimate accessories", products: [] },
    "Restraints": { href: "/collections/restraints-bondage", handle: "restraints-bondage", desc: "Premium leather & silk restraints", products: [] },
    "Impact Play": { href: "/collections/impact-play", handle: "impact-play", desc: "Paddles, crops & sensation tools", products: [] },
    "Collars & Leashes": { href: "/collections/collars-leashes", handle: "collars-leashes", desc: "Luxury collar & leash sets", products: [] },
    "Sensory Play": { href: "/collections/sensory-play", handle: "sensory-play", desc: "Explore the senses with premium toys", products: [] }
  };
  var megaEl = null, hideTimeout = null, loaded = {};
  function fetchProducts(handle) {
    if (loaded[handle]) return Promise.resolve(loaded[handle]);
    return fetch("/collections/" + handle)
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        var cards = doc.querySelectorAll(".card-wrapper");
        var prods = [];
        cards.forEach(function(card) {
          if (prods.length >= 4) return;
          var imgEl = card.querySelector("img");
          var titleEl = card.querySelector(".card__heading a") || card.querySelector(".full-unstyled-link");
          var priceEl = card.querySelector(".price-item--regular") || card.querySelector(".price-item");
          if (imgEl && titleEl) {
            var imgSrc = imgEl.getAttribute("src") || "";
            if (imgSrc.indexOf("?") > -1) imgSrc = imgSrc.split("?")[0] + "?width=300";
            else imgSrc += "?width=300";
            prods.push({
              name: (titleEl.textContent || "").trim().substring(0, 40),
              price: priceEl ? priceEl.textContent.trim() : "",
              img: imgSrc,
              href: titleEl.getAttribute("href") || "/collections/" + handle
            });
          }
        });
        loaded[handle] = prods;
        return prods;
      })
      .catch(function() { return []; });
  }
  function createMegaMenu() {
    megaEl = document.createElement("div");
    megaEl.id = "df-mega-menu";
    megaEl.innerHTML = '<div class="dfm-inner"><div class="dfm-left"><h3 class="dfm-cat-title"></h3><p class="dfm-cat-desc"></p><a class="dfm-view-all" href="">View All \u2192</a></div><div class="dfm-right"><div class="dfm-products"></div></div></div>';
    document.body.appendChild(megaEl);
    megaEl.addEventListener("mouseenter", function() { clearTimeout(hideTimeout); });
    megaEl.addEventListener("mouseleave", function() { hideMega(); });
  }
  function renderProducts(container, products, fallbackHref) {
    if (!products || products.length === 0) {
      container.innerHTML = '<div style="color:rgba(255,255,255,0.3);font-size:0.8rem;padding:2rem;">Loading...</div>';
      return;
    }
    container.innerHTML = products.map(function(p) {
      var safeName = p.name.replace(/"/g, "");
      return '<a class="dfm-prod" href="' + (p.href || fallbackHref) + '"><div class="dfm-prod-img"><img src="' + p.img + '" alt="' + safeName + '" loading="eager" width="140" height="140"></div><span class="dfm-prod-name">' + p.name + '</span><span class="dfm-prod-price">' + p.price + '</span></a>';
    }).join("");
  }
  function showMega(menuItem, data) {
    clearTimeout(hideTimeout);
    if (!megaEl) createMegaMenu();
    var headerEl = document.querySelector(".section-header");
    var headerRect = headerEl.getBoundingClientRect();
    megaEl.querySelector(".dfm-cat-title").textContent = menuItem.textContent.trim();
    megaEl.querySelector(".dfm-cat-desc").textContent = data.desc;
    megaEl.querySelector(".dfm-view-all").href = data.href;
    var prodContainer = megaEl.querySelector(".dfm-products");
    if (loaded[data.handle] && loaded[data.handle].length > 0) {
      renderProducts(prodContainer, loaded[data.handle], data.href);
    } else {
      prodContainer.innerHTML = '<div style="color:rgba(255,255,255,0.3);font-size:0.8rem;padding:2rem;">Loading...</div>';
      fetchProducts(data.handle).then(function(prods) {
        if (megaEl.style.display === "block") renderProducts(prodContainer, prods, data.href);
      });
    }
    megaEl.style.top = headerRect.bottom + "px";
    megaEl.style.display = "block";
    requestAnimationFrame(function() { megaEl.classList.add("dfm-visible"); });
  }
  function hideMega() {
    hideTimeout = setTimeout(function() {
      if (megaEl) {
        megaEl.classList.remove("dfm-visible");
        setTimeout(function() { megaEl.style.display = "none"; }, 300);
      }
    }, 200);
  }
  function init() {
    var handles = Object.keys(menuData).map(function(k) { return menuData[k].handle; });
    handles.forEach(function(h) { fetchProducts(h); });
    document.querySelectorAll(".header__menu-item").forEach(function(item) {
      var text = item.textContent.trim();
      var matchKey = Object.keys(menuData).find(function(k) { return text.toLowerCase().indexOf(k.toLowerCase()) > -1; });
      if (matchKey) {
        item.addEventListener("mouseenter", function() { showMega(item, menuData[matchKey]); });
        item.addEventListener("mouseleave", function() { hideMega(); });
      }
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();